import {log} from "./logEvent";

export default function(errorMsg, sourceUrl, lineNumber, columnNumber, errorObject) {
    const errorEvent = { url: sourceUrl, lineNumber: lineNumber, errorMessage: errorMsg };

    if (errorObject) {
        const errorEventWithStack = {...errorEvent, stack: errorObject.stack};
        log("ui-javascript-error", errorEventWithStack);
    } else {
        log("ui-javascript-error", errorEvent);
    }

    return false;
};
